export const getProjectExportData = (projects) => {
  //updated Harish 2024-06-17: Added more fields and handled missing data gracefully
  return projects.map((l) => ({
    // 1. Basic & Contact Info
    "First Name": l.firstName || "",
    "Last Name": l.lastName || "",
    "Phone": l.phoneNumber || l.phone || "",
    "Email": l.email || "",

    // 2. Address
    "Address Line 1": l.addressLine1 || "",
    "Address Line 2": l.addressLine2 || "",
    "City": l.city || "",
    "District": l.district || "",
    "State": l.state || "",
    "PIN Code": l.pincode || "",
    "Office Location": l.officeLocation || "",

    // 3. Source & General
    "Reference Source": l.referenceType || "",
    "Assign Project Manager (Optional)": l.projectManager?.name || l.projectManager?.firstName || l.projectManagerId?.name || "Unassigned",
    "Property Type": l.propertyType || "",
    "Type": l.requirementType || "",
    "Estimated Budget (₹)": l.budget || 0,
    "Notes": l.notes || l.lastNote || "",

    // 4. Project Stages
    "Current Stage": l.leadStatus?.replace(/_/g, ' ').toUpperCase() || "—",
    "Design": l.designStatus?.replace(/_/g, ' ').toUpperCase() || "—",
    "Design Approval": l.designApproval?.mainDesigner?.status?.toUpperCase() || l.designApproval?.designer?.status?.toUpperCase() || "—",
    "Final Quotation": l.leadStatus === 'final_quotation' ? 'Active' : "—",
    "Final Quotation Approval": l.finalQuotationApproval?.approvalStatus?.toUpperCase() || "—",
    "Sign Off": l.leadStatus === 'documents' ? 'Active' : "—",
    "Started": l.leadStatus === 'project_started' || l.status === 'project_started' ? 'Yes' : "No"
  }));
};
